if (!customElements.get('size-guide-modal')) {
  customElements.define('size-guide-modal', class SizeGuideModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="SizeGuideInfo-"]');
    }

    hide(preventFocus = false) {
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if (window.SizeGuideModal) window.SizeGuideModal.loadShopifyXR();

      super.show(opener);
      
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
      
    }

  });
}
